import { render, staticRenderFns } from "./ManagePlatform.vue?vue&type=template&id=1a7f7bba&scoped=true&"
import script from "./ManagePlatform.vue?vue&type=script&lang=js&"
export * from "./ManagePlatform.vue?vue&type=script&lang=js&"
import style0 from "./ManagePlatform.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ManagePlatform.vue?vue&type=style&index=1&id=1a7f7bba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7f7bba",
  null
  
)

export default component.exports